
export interface IconProps {
  className?: string;
  style?: React.CSSProperties;
}

export function HamburgerIcon({ className = '', style }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <line x1="4" y1="7" x2="20" y2="7" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="17" x2="20" y2="17" />
    </svg>
  );
}

export function CloseIcon({ className = '', style }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </svg>
  );
}

// ==========================================================
// Brand mark — mini lacăt inspirat de codex (SVG inline)
// ==========================================================

export function BrandMark() {
  // Replică mark-ul din codex-v6: lacăt cu gradient mint + glow. Pseudo-
  // elemente-le (arc + corp) desenate direct via box-shadow, border și
  // backgrounds — fără SVG, ca să păstrăm look-ul solid al mock-ului.
  return (
    <div
      className="w-[28px] h-[28px] rounded-lg grid place-items-center relative flex-shrink-0"
      style={{ background: 'var(--grad-mint)', boxShadow: 'var(--glow-mint)' }}
      aria-hidden
    >
      {/* Arcul — border top cu colțuri rotunjite, cuiul lacătului */}
      <span
        style={{
          position: 'absolute',
          top: 4,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 10,
          height: 11,
          border: '1.75px solid #042c21',
          borderBottom: 'none',
          borderRadius: '5px 5px 0 0',
        }}
      />
      {/* Corpul lacătului */}
      <span
        style={{
          position: 'absolute',
          bottom: 5,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 16,
          height: 10,
          background: '#042c21',
          borderRadius: 2,
        }}
      />
    </div>
  );
}
